import { useMemo } from 'react'

import { Embed } from '@tribeplatform/gql-client/types'
import { Link } from '@tribeplatform/react-ui-kit/Link'

import { Image } from '../../../common/components/Image.js'

interface Props {
  embed: Embed
  imageSize?: number
}

export const EmbedRenderer = ({ embed, imageSize = 60 }: Props) => {
  const { title, author, description, thumbnailUrl, url } = useMemo(() => {
    const { author, url } = embed
    const title = embed.title ?? embed.provider_name ?? 'Not found'
    const description = embed.description ?? '...'
    const thumbnailUrl = embed.thumbnail_url ?? url

    return { title, author, description, thumbnailUrl, url }
  }, [embed])

  return (
    <div
      className="flex gap-2 p-2 max-h-full overflow-hidden cursor-pointer"
      onClick={e => {
        e.stopPropagation()
        window.open(url ?? thumbnailUrl, '_blank')
      }}
    >
      <div className="flex gap-1 truncate items-center">
        <Image
          src={thumbnailUrl}
          alt={title}
          width={imageSize}
          height={imageSize}
          className="object-cover rounded-base"
        />
        <div className="flex flex-col truncate">
          <div className="truncate text-sm">
            <Link target="_blank" href={embed.url}>
              {title}
            </Link>
            <span className="text-content-subdued text-xs">
              {author ? ` | ${author}` : ''}
            </span>
          </div>
          <div className="text-content-subdued text-start text-xs truncate max-w-full">
            {description}
          </div>
        </div>
      </div>
    </div>
  )
}
